/**
 * Registers <wishlist-drawer>, extending the theme's own Drawer component (same class used by <cart-drawer>) so it
 * gets identical animation, overlay, ESC-to-close and outside-click behaviour for free — no drawer logic duplicated.
 * The only override is the slide direction: forced to "right" on all breakpoints (the base Drawer opens from the
 * bottom on small screens).
 */
import { Drawer } from 'theme';

class WishlistDrawer extends Drawer {
  get openFrom() {
    return this.getAttribute('open-from') || 'right';
  }
}

if (!customElements.get('wishlist-drawer')) {
  customElements.define('wishlist-drawer', WishlistDrawer);
}
